import slatinaImage from '../images/slatina.png';
import cherniVrahImage from '../images/cherni-vrah.jpg';

// Id-тата съвпадат с таблицата Locations в бекенда (1 = Слатина, 2 = Черни връх).
export const SLATINA_ID = 1;
export const CHERNI_VRAH_ID = 2;

// Телефон на Слатина (общ за сайта) — новият салон има собствен номер.
export const PHONE_DISPLAY = '088 422 7335';
export const PHONE_LINK = 'tel:+359884227335';

export const LOCATIONS = {
  [SLATINA_ID]: {
    id: SLATINA_ID,
    name: "Alexiev's Barbershop",
    shortName: 'Слатина',
    address: 'ул. Слатинска, бл. 44А, София',
    phoneDisplay: '088 422 7335',
    phoneLink: 'tel:+359884227335',
    image: slatinaImage,
    imagePosition: 'object-center',
    isNew: false,
  },
  [CHERNI_VRAH_ID]: {
    id: CHERNI_VRAH_ID,
    name: "Alexiev's Barbershop — La Barberia",
    shortName: 'Черни връх',
    address: 'бул. Черни връх 74, вх. А, София',
    phoneDisplay: '088 704 8641',
    phoneLink: 'tel:+359887048641',
    image: cherniVrahImage,
    imagePosition: 'object-[center_35%]',
    isNew: true,
  },
};

export const LOCATION_LIST = [LOCATIONS[SLATINA_ID], LOCATIONS[CHERNI_VRAH_ID]];

// Статични ценоразписи за показване (вкл. услугите само по телефон).
// Цените за онлайн резервация идват от API-то — това е маркетинговият списък.
export const LOCATION_PRICE_LISTS = {
  [SLATINA_ID]: [
    { id: 1, name: 'Подстрижка', description: 'Коса - 30 Мин', priceLabel: '15 € · Сотир 13 € · Георги 10 €' },
    { id: 2, name: 'Брада', description: 'Брада - 30 Мин', priceLabel: '12 € · Сотир 10 € · Георги 7 €' },
    { id: 3, name: 'Коса + брада', description: 'Коса, брада - 1 час', priceLabel: '25 € · Сотир 20 € · Георги 15 €' },
    { id: 4, name: 'Коса + брада + дълбоко почистване на лице', description: '1 час и 30 Мин', priceLabel: '35 € · Сотир 31 € · Георги 25 €' },
    { id: 5, name: 'Коса + брада + боя', description: '1 час и 30 Мин', priceLabel: '30 €' },
    { id: 7, name: 'Дълбоко почистване на лице', description: '30 Мин', priceLabel: '13 €' },
    { id: 9, name: 'Кралско бръснене', description: '30 Мин', priceLabel: '13 €' },
    { id: 10, name: 'Коса + дълбоко почистване на лице', description: '60 Мин', priceLabel: '25 €' },
    { id: 13, name: 'Брада + боя', description: '60 Мин', priceLabel: '18 €' },
    { id: 14, name: 'Кола маска', description: 'За резервация по телефон', priceLabel: '3 €' },
    { id: 15, name: 'Вежди с конец', description: 'За резервация по телефон', priceLabel: '5 €' },
  ],
  [CHERNI_VRAH_ID]: [
    { id: 1, name: 'Подстрижка', description: 'Коса - 30 Мин', priceLabel: 'Емил 18 € / Марио 15 €' },
    { id: 2, name: 'Брада', description: 'Брада - 30 Мин', priceLabel: 'Емил 15 € / Марио 12 €' },
    { id: 3, name: 'Коса + брада', description: 'Коса, брада - 1 час', priceLabel: 'Емил 30 € / Марио 25 €' },
    { id: 4, name: 'Коса + брада + дълбоко почистване на лице', description: '1 час и 30 Мин', priceLabel: 'Емил 40 € / Марио 35 €' },
    { id: 7, name: 'Дълбоко почистване на лице', description: '30 Мин', priceLabel: '15 €' },
    { id: 20, name: 'Боя', description: 'За резервация по телефон', priceLabel: '10 €' },
    { id: 21, name: 'Вежди с конец', description: 'За резервация по телефон', priceLabel: '7 €' },
    { id: 22, name: 'Кола маска', description: 'За резервация по телефон', priceLabel: '5 € / зона' },
  ],
};

export const OVERTIME_NOTE =
  'Извън работно време (след 19:00 ч.) — резервация само по телефон, цена +50 %.';
